export default __webpack_public_path__ + "static/media/covidSymptoms.488cc9c8.svg";